// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  1. Use a more-intuitive box-sizing model.
*/
*,
*::before,
*::after {
  box-sizing: border-box;
}
/*
  2. Remove default margin
*/
* {
  margin: 0;
}
/*
  Typographic tweaks!
  3. Add accessible line-height
  4. Improve text rendering
*/
body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}
/*
  5. Improve media defaults
*/
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}
/*
  6. Remove built-in form typography styles
*/
input,
button,
textarea,
select {
  font: inherit;
}
/*
  7. Avoid text overflows
*/
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}
/*
  8. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

body {
  height: 100vh;
  width: 100vw;
  display: grid;
  grid-template-rows: 50px 1fr 50px;
  grid-template-columns: 1fr;

  align-content: center;
  align-items: center;
  justify-content: center;
}

header {
  display: flex;
  justify-content: center;
}

.headerFooter {
  background-color: black;
  color: white;
}

main {
  width: 100%;
  height: 100%;
  text-align: center;
  display: grid;
  grid-template-columns: 1fr;

  align-content: center;
  align-items: center;
  justify-content: center;
  align-self: center;

  gap: 10px;
}

.boards {
  height: 30%;
  width: 80%;
  justify-self: center;
  justify-content: center;
  justify-items: center;
  align-content: center;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;

  gap: 10px;
}

.player {
  display: grid;
  gap: 10px;
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(10, 1fr);
}
.row {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: 1fr;
}

.space {
  background-color: rgba(52, 114, 11, 0.795);

  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
}

.space:hover {
  background-color: #ccc;
}

.yaks {
  display: flex;
  gap: 12px;

  justify-content: space-evenly;
}

.yaks > * {
  opacity: 1;
}

.hidden {
  opacity: 0.3;
}

#placementForm {
  display: grid;
  gap: 10px;
  padding: 18px;
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;;;EAGE,sBAAsB;AACxB;AACA;;CAEC;AACD;EACE,SAAS;AACX;AACA;;;;CAIC;AACD;EACE,gBAAgB;EAChB,mCAAmC;AACrC;AACA;;CAEC;AACD;;;;;EAKE,cAAc;EACd,eAAe;AACjB;AACA;;CAEC;AACD;;;;EAIE,aAAa;AACf;AACA;;CAEC;AACD;;;;;;;EAOE,yBAAyB;AAC3B;AACA;;CAEC;AACD;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,0BAA0B;;EAE1B,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,0BAA0B;;EAE1B,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;;EAElB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;;EAE3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;;EAE1C,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;;EAET,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV","sourcesContent":["/*\n  1. Use a more-intuitive box-sizing model.\n*/\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n/*\n  2. Remove default margin\n*/\n* {\n  margin: 0;\n}\n/*\n  Typographic tweaks!\n  3. Add accessible line-height\n  4. Improve text rendering\n*/\nbody {\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n/*\n  5. Improve media defaults\n*/\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n/*\n  6. Remove built-in form typography styles\n*/\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n/*\n  7. Avoid text overflows\n*/\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n/*\n  8. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n}\n\nbody {\n  height: 100vh;\n  width: 100vw;\n  display: grid;\n  grid-template-rows: 50px 1fr 50px;\n  grid-template-columns: 1fr;\n\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n}\n\nheader {\n  display: flex;\n  justify-content: center;\n}\n\n.headerFooter {\n  background-color: black;\n  color: white;\n}\n\nmain {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  display: grid;\n  grid-template-columns: 1fr;\n\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n\n  gap: 10px;\n}\n\n.boards {\n  height: 30%;\n  width: 80%;\n  justify-self: center;\n  justify-content: center;\n  justify-items: center;\n  align-content: center;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr 1fr;\n\n  gap: 10px;\n}\n\n.player {\n  display: grid;\n  gap: 10px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(10, 1fr);\n}\n.row {\n  display: grid;\n  grid-template-columns: repeat(10, 1fr);\n  grid-template-rows: 1fr;\n}\n\n.space {\n  background-color: rgba(52, 114, 11, 0.795);\n\n  border: 1px solid black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.space:hover {\n  background-color: #ccc;\n}\n\n.yaks {\n  display: flex;\n  gap: 12px;\n\n  justify-content: space-evenly;\n}\n\n.yaks > * {\n  opacity: 1;\n}\n\n.hidden {\n  opacity: 0.3;\n}\n\n#placementForm {\n  display: grid;\n  gap: 10px;\n  padding: 18px;\n}\n\n.buttons {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
